import { cn } from "@/lib/utils"

/**
 * Skeleton — UI Foundation Phase 1 (A7).
 * Use for content whose shape is known (table rows, KPI, cards); never as a
 * generic replacement for an empty state.
 */
function Skeleton({ className, ...props }) {
  return (
    <div
      data-testid="skeleton"
      className={cn("animate-pulse rounded-md bg-surface-sunken", className)}
      {...props} />
  );
}

/** Table placeholder: `rows` × `cols` cells with the real row rhythm. */
function SkeletonTable({ rows = 6, cols = 4, className }) {
  return (
    <div data-testid="skeleton-table" className={cn("w-full space-y-2", className)}>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-3">
          {Array.from({ length: cols }).map((__, c) => (
            <Skeleton
              key={c}
              className={cn("h-8 flex-1", c === 0 && "flex-[2]")}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export { Skeleton, SkeletonTable }
